import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { AtendimentoMedicoConsultaDto, AtendimentoMedicoEdicaoDto, AtendimentoMedicoInsercaoDto } from '../dtos/atendimentos/atendimento-medico-dto';
import { DesvincularExamesEntrada } from '../dtos/atendimentos/desvincular-exames-entrada';
import { LAtendimentoAgenteDto, LAtendimentoAgenteOrigemDestinoDto } from '../dtos/atendimentos/l-atendimento-agente-dto';
import { LAtendimentoDoencaAtivaInativaDto, LAtendimentoDoencaDto } from '../dtos/atendimentos/l-atendimento-doenca-dto';
import { LAtendimentoMedicoExameDto } from '../dtos/atendimentos/l-atendimento-exame-dto';
import { LAtendimentoMedicoDto } from '../dtos/atendimentos/l-atendimento-medico-dto';
import { VincularExamesEntrada } from '../dtos/atendimentos/vincular-exames-entrada';
import { DocumentoDto } from '../dtos/docs/documento-dto';
import { NaoExecucaoDto } from '../dtos/atendimentos/nao-execucao-dto';
import { DadosComumService } from './dados-comum.service';
import { DocsService } from './docs.service';
import { UrlService } from './url.service';
import { AxSelectComponent } from '../libs/ax-select/ax-select.component';
import { SelectDataSource } from '../libs/ax-select/select-data-source';

@Injectable({
  providedIn: 'root'
})
export class AtendimentoService {

  constructor(private url: UrlService, private http: HttpClient,
    private docs: DocsService, private ds: DadosComumService) { }

  listarAtendimentos(pessoaId: number): Observable<LAtendimentoMedicoDto[]> {
    let p = new HttpParams();
    
    let filtro = p
    .append('pessoaId', pessoaId);

    return this.http.get<LAtendimentoMedicoDto[]>(this.url.url('atendimentos-medicos'), { params: filtro });
  }

  listarExames(atendimentoId: number): Observable<LAtendimentoMedicoExameDto[]> {
    let p = new HttpParams();

    return this.http.get<LAtendimentoMedicoExameDto[]>(this.url.url(`atendimentos-medicos/${atendimentoId}/exames`));
  }

  listarAgentes(atendimentoId: number): Observable<LAtendimentoAgenteOrigemDestinoDto> {
    let p = new HttpParams();

    return this.http.get<LAtendimentoAgenteOrigemDestinoDto>(this.url.url(`atendimentos-medicos/${atendimentoId}/agentes`));
  }

  listarDoencas(atendimentoId: number): Observable<LAtendimentoDoencaAtivaInativaDto> {
    let p = new HttpParams();

    return this.http.get<LAtendimentoDoencaAtivaInativaDto>(this.url.url(`atendimentos-medicos/${atendimentoId}/doencas`));
  }

  dsConsultationReasons(): SelectDataSource {
    let ds = new SelectDataSource();
    ds.url = this.url.url('motivos-consultas/selecao');
    return ds;
  }

  salvarAtendimento(atendimento: AtendimentoMedicoInsercaoDto | AtendimentoMedicoEdicaoDto): Observable<AtendimentoMedicoConsultaDto> {
    var salvar = this.http.post<AtendimentoMedicoConsultaDto>(this.url.url('atendimentos-medicos/'), atendimento);

    if('id' in atendimento && atendimento.id !== null && atendimento.id > 0) 
      salvar =  this.http.patch<AtendimentoMedicoConsultaDto>(this.url.url('atendimentos-medicos/'), atendimento);

    salvar.pipe(map((val) => {
      val.data = new Date(val.data);
      val.pessoaDataNascimento = new Date(val.pessoaDataNascimento);
      return val;
    }));

    return salvar;
  }

  gerarDocumentoReferencia(documento: DocumentoDto) : Observable<string>  {
    if(documento.id) {
      return of(documento.id)
    }
/*
    let doc: DocumentoDto = {
      id: '',
      titulo: atendimento.pessoaNome + ' - ' + this.ds.atendimentoTipoParaTexto(atendimento.tipo),
      descricao: '',
      documentoTipoId: 14, // ASO.
      documentoTipoTexto: '',
      ativo: true,
      validavel: true,
      assinaturaExterna: false,
      assinaturaManual: false,
      possuiSenha: true,
      possuiArquivo: false,
      estabelecimentoId: atendimento.lotacaoDestino?.estabelecimentoId ?? atendimento.lotacaoOrigem.estabelecimentoId,
      periodicidadeId: null,
      data: atendimento.data,
      tenantId: atendimento.lotacaoDestino?.empresaId ?? atendimento.lotacaoOrigem.empresaId,
      senha: '',
      assinaturasSolicitadas: 0,
      assinaturasFinalizadas: 0,
      temporario: true
    }*/

    return this.docs.inserirDocumento(documento).pipe(map((doc) => doc.id));
  }

  excluirAtendimento(id: number): Observable<void> {
    return this.http.delete<void>(this.url.url(`atendimentos-medicos/${id}`));
  }

  consultarAtendimento(id: number): Observable<AtendimentoMedicoConsultaDto> {
    return this.http.get<AtendimentoMedicoConsultaDto>(this.url.url('atendimentos-medicos/' + id));
  }

  vincularExames(entrada: VincularExamesEntrada): Observable<void> {
    return this.http
    .post<void>(this.url.url(`atendimentos-medicos/exames/vinculacao`), entrada);
  }

  desvincularExames(entrada: DesvincularExamesEntrada): Observable<void> {
    return this.http
    .post<void>(this.url.url(`atendimentos-medicos/exames/desvinculacao`), entrada);
  }

  inserirNaoExecucao(entrada: NaoExecucaoDto): Observable<AtendimentoMedicoConsultaDto>{
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    const url = this.url.url('atendimentos-medicos/nao-execucoes');
    return this.http.patch<AtendimentoMedicoConsultaDto>(url, entrada, { headers });
    
  }










}
